import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ToBePaid } from '../../../models/to-be-paid';

import { ToBePaidService } from '../../../services/accounting/to-be-paid.service';

@Component({
  selector: 'app-to-be-paid',
  templateUrl: './to-be-paid.component.html',
  styleUrls: ['./to-be-paid.component.css'],
})
export class ToBePaidComponent implements OnInit {
  loading: boolean = true;

  @Input() toBePaidId: number | null;

  toBePaid: ToBePaid;

  tree: Array<ToBePaid>;

  constructor(private toBePaidService: ToBePaidService, private route: ActivatedRoute) {}

  ngOnInit() {
    if (!this.toBePaidId) this.toBePaidId = Number(this.route.snapshot.params['id']);
    this.loadToBePaid();
  }

  loadToBePaid() {
    this.toBePaidService.getToBePaid(this.toBePaidId!).then((response_json) => {
      this.toBePaid = response_json.to_be_paid;
      this.tree = response_json.tree;
      this.loading = false;
    });
  }

  statusName(status: string): string {
    switch (status) {
      case 'outstanding':
        return 'warning';
      case 'void':
        return 'dark';
      case 'paid':
        return 'success';
      case 'contested':
        return 'danger';
      default:
        return 'light';
    }
  }
}
